const FILTERS = {
    "integrated-solutions": {
        server_model: {
            title: 'Server Model',
            icon: 'server.png'
        },
        cpu_generation: {
            title: 'CPU Generation',
            iconClass: 'project-diagram'
        },
        server_software_version: {
            title: 'Server Software Version',
            icon: 'server.png'

        },
        operating_system: {
            title: 'Operating System',
            icon: 'os.png'
        },
        controller: {
            title: 'Controller',
            icon: 'server.png',
            dynamic: true
        },
        nic: {
            title: 'NIC',
            icon: 'hba_driver.png'
        },
        hba: {
            title: 'HBA ',
            icon: 'hba.png'
        },
        gpu: {
            title: 'GPU',
            icon: 'hba.png'
        },
        drive: {
            title: 'Drive',
            icon: 'hba_driver.png'
        },
        boot_options: {
            title: "Boot Options",
            icon: 'hba.png'
        },

    }
}
export default FILTERS;